module.exports = __webpack_public_path__ + "img/RiskOfLargePackage.d932173f.svg";